import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import '@babel/polyfill';
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VueCurrencyFilter from 'vue-currency-filter';
import VueMasonry from 'vue-masonry-css';
import moment from 'moment';
import ld from 'lodash';
import 'moment/locale/it';
import http from './http';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import sessionTools from './mixins/sessionTools';
import buildStore from './store';
import './filters';
import './directives/overlay';
// import './registerServiceWorker';

import TcloudComp from '@/components/TcloudComp.vue';
import TChart from '@/components/TChart.vue';
import BadgeLocale from '@/components/BadgeLocale.vue';

moment.locale('it');

Vue.config.productionTip = false;
Vue.http = Vue.prototype.$http = http; //eslint-disable-line
Vue.prototype.$get = ld.get;

Vue.prototype.hexToRgb = (hex, alpha = null) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const format = alpha !== null ? 'rgba' : 'rgb';
  return `${format}(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}${alpha !== null ? `, ${alpha}` : ''})`;
};

Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
});
Vue.use(VueMasonry);

Vue.component('tchart', TChart);
Vue.component('tcloud-comp', TcloudComp);
Vue.component('badge-locale', BadgeLocale);

Vue.mixin(sessionTools);

const store = buildStore(router);

router.beforeEach((to, from, next) => {
  if (store.getters['Session/loggedIn'] || to.path === '/') next();
  else next('/');
});

sync(store, router, { moduleName: 'Router' });

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
